import _ from 'underscore'

    ;

(($) => {
    $.fn.storymapAdvanced = function (options) {
        let breakpointPos = '33.333%'

        if (window.matchMedia('(max-width: 1000px)').matches) {
            const roadTripTop = $('[data-id="road-trip-block"]').offset().top
            const roadTripScreenMode = '[data-trigger="road-trip-screenmode"]'
            const roadTripScreenModeBottom =
                $(roadTripScreenMode).offset().top + $(roadTripScreenMode).outerHeight(true)
            breakpointPos = roadTripScreenModeBottom - roadTripTop + 20
        }

        const defaults = {
            selector: '[data-place]',
            breakpointPos: breakpointPos,

            addTrace: (map, coordinates, trace_color) => {
                map.on('load', () => {
                    map.addSource('trace', {
                        type: 'geojson',
                        data: {
                            type: 'Feature',
                            properties: {},
                            geometry: {
                                type: 'LineString',
                                coordinates: coordinates,
                            },
                        },
                    })
                    map.addLayer({
                        id: 'trace',
                        type: 'line',
                        source: 'trace',
                        layout: {
                            'line-join': 'round',
                            'line-cap': 'round',
                        },
                        paint: {
                            'line-color': trace_color,
                            'line-width': 3,
                        },
                    })
                })
            },
        }

        const settings = $.extend(defaults, options)

        const arrayPositionStepLeft = []
        const arrayPositionStepTop = []
        $(options.current_block.find('[data-id="road-trip-sidebar-step-item"]')).each(function (i) {
            arrayPositionStepLeft[i + 1] = $(this).offset().left
            arrayPositionStepTop[i + 1] = $(this).position().top
        })

        if (typeof Map === 'undefined') {
            throw new Error('Storymap requires Maplibre')
        }
        if (typeof _ === 'undefined') {
            throw new Error('Storymap requires underscore.js')
        }

        function getDistanceToTop(elem, top) {
            const docViewTop = $(window).scrollTop()

            const elemTop = $(elem).offset().top

            const dist = elemTop - docViewTop

            const d1 = top - dist

            if (d1 < 0) {
                return elemTop + $(elem).outerHeight()
            }
            return d1
        }

        function highlightTopPara(paragraphs, top) {
            const distances = _.map(paragraphs, (element) => {
                const dist = getDistanceToTop(element, top)
                return {
                    el: $(element),
                    distance: dist,
                }
            })

            const closest = _.min(distances, (dist) => dist.distance)

            _.each(paragraphs, (element) => {
                const paragraph = $(element)
                if (paragraph[0] !== closest.el[0]) {
                    paragraph.trigger('notviewing')
                }
            })

            if (!closest.el.hasClass('viewing')) {
                closest.el.trigger('viewing')
            }
        }

        function watchHighlight(element, searchfor) {
            let top = $('[data-element="breakpoint-current"]').offset().top - $(window).scrollTop()
            const paragraphs = element.find(searchfor)
            highlightTopPara(paragraphs, top)
            $(window).scroll(() => {
                top = $('[data-element="breakpoint-current"]').offset().top - $(window).scrollTop()
                highlightTopPara(paragraphs, top)
            })
        }

        function addPoi() {
            $(window.IrisMap.maps).each((index, map) => {
                const roadtripMapElement = map.domElement.attributes.getNamedItem('data-id')

                if (roadtripMapElement !== null && roadtripMapElement.value === 'road-trip-map') {
                    $('[data-id="road-trip-step"]').each(function () {
                        const step = $(this).attr('data-step')

                        $(this)
                            .find('[data-id="interest-points-item"]')
                            .each(function () {
                                const marker = map.Marker()
                                const poiId = $(this).attr('id')
                                const position = {
                                    lat: Number.parseFloat($(this).attr('data-latitude')),
                                    lng: Number.parseFloat($(this).attr('data-longitude')),
                                }

                                const poiOptions = {
                                    className: 'marker-poi',
                                    backgroundSize: '100%',
                                    height: 25,
                                    width: 25,
                                    attributes: {
                                        'data-poi-marker': step,
                                        'data-poi-marker-id': poiId,
                                    },
                                }

                                // Marker
                                marker.setLngLat(position)
                                marker.addTo(map)
                                marker.setMarkerImage('', poiOptions)

                                // Popup
                                const infobox = $(
                                    '[id="' + poiId + '"][data-id="interest-points-item-infobox"]',
                                ).html()
                                if (infobox !== '') {
                                    const popup = map
                                        .Popup(
                                            {
                                                closeButton: false,
                                                closeOnClick: true,
                                            },
                                            1,
                                        )
                                        .setText(infobox)

                                    marker.setPopup(popup)
                                }
                            })
                    })
                }
            })
        }

        function hoverPoi() {
            $('[data-id="interest-points-item"]').hover(
                function () {
                    const id = $(this).attr('id')
                    $('[data-poi-marker-id="' + id + '"]').addClass('hover')
                },
                () => {
                    $('[data-poi-marker-id]').removeClass('hover')
                },
            )
        }

        const makeStoryMap = (element) => {
            const topElem = $(
                '<div class="breakpoint-current" data-element="breakpoint-current"></div>',
            )
                .css('top', settings.breakpointPos)
                .css('position', 'fixed')
            const searchfor = settings.selector
            const paragraphs = element.find(searchfor)

            $('body').append(topElem)
            watchHighlight(element, searchfor)

            function showMapView(key) {
                const marker = document.querySelector('[data-place="' + key + '"]')

                if (marker) {
                    const step = marker.dataset.step
                    const latitude = marker.dataset.latitude
                    const longitude = marker.dataset.longitude
                    const zoomLevel = marker.dataset.zoom
                    const bearingLevel = marker.dataset.bearing
                    const pitchLevel = marker.dataset.pitch
                    const allMarkers = '[data-marker]'
                    const allPois = '[data-poi-marker]'
                    const currentMarker = "[data-marker='" + step + "']"
                    const currentPois = "[data-poi-marker='" + step + "']"
                    const markerImgActive = window.IrisMap.config.main.markerHoverNumbersUrl[step]

                    $(allMarkers).removeClass('active')
                    $(allPois).removeClass('active')
                    $(currentMarker).addClass('active')
                    $(currentPois).addClass('active')

                    // Switch active state on markers imgUrl
                    $(allMarkers).each(function () {
                        const markerImg =
                            window.IrisMap.config.main.markerNumbersUrl[$(this).attr('data-marker')]
                        $(this).css('background-image', 'url(' + markerImg + ')')
                    })
                    $(currentMarker).css('background-image', 'url(' + markerImgActive + ')')

                    $(window.IrisMap.maps).each((index, map) => {
                        const roadtripMapElement = map.domElement.attributes.getNamedItem('data-id')

                        if (
                            roadtripMapElement !== null &&
                            roadtripMapElement.value === 'road-trip-map'
                        ) {
                            map.flyTo({
                                center: [longitude, latitude],
                                pitch: pitchLevel,
                                bearing: bearingLevel,
                                zoom: zoomLevel,
                            })
                        }
                    })
                }
            }

            function changeValue(element, value) {
                const replace = options.current_block.find(element)
                $(replace).html(value)
            }

            function activeStep(key) {
                const roadTripStepItem = options.current_block.find(
                    '[data-id="road-trip-sidebar-step-item"][data-value="' + key + '"]',
                )
                const left = arrayPositionStepLeft[key]
                const top = arrayPositionStepTop[key]
                const width = $(window).outerWidth()
                const height = $('[data-id="road-trip-map-sidebar"]').outerHeight()

                options.current_block
                    .find('[data-id="road-trip-sidebar-step-item"]')
                    .removeClass('active')
                roadTripStepItem.addClass('active')

                if (window.matchMedia('(max-width: 1000px)').matches) {
                    if (left > width) {
                        const swift = width - left
                        $('[data-id="road-trip-sidebar-step-list"]').css(
                            'transform',
                            'translateX(' + swift + 'px)',
                        )
                    } else {
                        $('[data-id="road-trip-sidebar-step-list"]').css('transform', 'none')
                    }
                } else {
                    if (top > height) {
                        const swift = height - top
                        $('[data-id="road-trip-sidebar-step-list"]').css(
                            'transform',
                            'translateY(' + swift + 'px)',
                        )
                    } else {
                        $('[data-id="road-trip-sidebar-step-list"]').css('transform', 'none')
                    }
                }
            }

            function triggerActiveStep() {
                const selector = '[data-id="road-trip-sidebar-step-item"], [data-marker]'

                options.current_block.on('click', selector, function (e) {
                    e.preventDefault()
                    let step = ''

                    if ($(this).hasClass('marker')) {
                        step = $(this).attr('data-marker')
                    } else {
                        step = $(this).attr('data-value')
                    }
                    let shift = 0

                    if (window.matchMedia('(max-width: 1000px)').matches) {
                        shift =
                            options.current_block
                                .find('[data-id="road-trip-map-container"]')
                                .outerHeight() +
                            options.current_block
                                .find('[data-id="road-trip-map-sidebar"]')
                                .outerHeight()

                        if (
                            options.current_block
                                .find('[data-id="road-trip-map-container"]')
                                .hasClass('full')
                        ) {
                            shift = 0
                        }
                    } else {
                        shift = options.current_block
                            .find('[data-id="road-trip-map-topbar"]')
                            .outerHeight()
                    }

                    const stepContent = options.current_block.find('[data-step="' + step + '"]')
                    const scrollTop = stepContent.offset().top - shift

                    $('html, body').animate(
                        {
                            scrollTop: scrollTop,
                        },
                        400,
                        () => {
                            $(stepContent).attr('tabindex', '-1')
                            $(stepContent).addClass('not-focus-style')
                            $(stepContent).focus()
                        },
                    )
                })
            }

            $(document).bind('roadtrip-map-load', triggerActiveStep)
            triggerActiveStep()

            paragraphs.on('viewing', function () {
                $(this).addClass('viewing')
                showMapView($(this).data('place'))

                if (window.matchMedia('(min-width: 1000px)').matches) {
                    changeValue(
                        '[data-id="road-trip-map-topbar-title"]',
                        $(this).find('[data-id="wpiris-step-title"]').html(),
                    )
                    changeValue(
                        '[data-id="road-trip-map-topbar-step-number"]',
                        $(this).data('step'),
                    )
                    changeValue(
                        '[data-id="road-trip-map-topbar-metas"]',
                        $(this).find('[data-id="wpiris-step-metas"]').html(),
                    )
                }
                activeStep($(this).data('step'))
            })

            $(document).on('update_roadtrip_map', () => {
                setTimeout(() => {
                    window.IrisMap.map.resize()
                }, 100)
            })

            paragraphs.on('notviewing', function () {
                $(this).removeClass('viewing')
            })
        }
        makeStoryMap(this, settings.markers)

        $(document).on('iris-map-is-loaded', () => {
            addPoi()
            hoverPoi()
        })

        return this
    }
})(jQuery)
